// DOM content loaded event listener
document.addEventListener("DOMContentLoaded", function () {
  var swiperProgressbar = new Swiper(".swiper-related-products", {
    loop: true,
    spaceBetween: 16,
    slidesPerView: 3,

    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
      // type: 'fraction',
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    on: {
      init: function () {
        updateCounter(this);
      },
      slideChange: function () {
        updateCounter(this);
      },
    },
  });

  function updateCounter(swiper) {
    const total = swiper.slides.length;
    const current = swiper.realIndex + 1;

    document.querySelector(
      ".swiper-pagination-counter-related-product .current",
    ).textContent = format(current);
    document.querySelector(
      ".swiper-pagination-counter-related-product .total",
    ).textContent = format(total);
  }

  function format(num) {
    return num < 10 ? "0" + num : num;
  }
});
